var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status_wrapper"},[_c('v-row',[_c('v-col',{staticClass:"m-auto",attrs:{"cols":"12","sm":"3","md":"3"}},[_c('b-card',{staticClass:"text-center",attrs:{"bg-variant":"dark","header":`VISITAS`}},[_c('b-card-text',[_vm._v("6")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }